module.exports = __webpack_public_path__ + "img/logoFt.7600bad5.png";